import React, {Component} from "react";


export default class Footer extends Component {

	render() {
		var style= {
			'marginTop': '20px',
			'borderTop': '1px solid gray'
		};

		var style2 = {
			'paddingTop': '10px'
		}
		return(
			<footer className="text-center" style={style}>
				<p style={style2}>Copyright &copy; andrideng.com</p>
			</footer>
		       
		);
	}
}



// WEBPACK FOOTER //
// ./src/auth_pages/components/Footer.js